import { questions_ptBR } from "./questions.pt-BR";
import { questions_enUS } from "./questions.en-US";

export default {
  "pt-BR": questions_ptBR,
  "en-US": questions_enUS
};
